import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { submit } from 'redux-form'
import moment from 'moment'

import { Modal } from 'Components/Modal'
import { ModalBody } from 'Components/Modal/ModalBody'
import { ModalFooter } from 'Components/Modal/ModalFooter'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { ModalTitle } from 'Components/Modal/ModalTitle'

import { PickupTimeAddForm } from 'Containers/Form/City/PickupTimes/PickupTimeAdd/index'

import { addPickupTime } from 'Reducers/PickupTimes/actions'
import SubmitButton from 'Components/Form/SubmitButton'

class PickupTimesAddModal extends React.Component {
  render() {
    const { handleCancel, modalShow, submitPickupTimeAddForm } = this.props

    return (
      <Modal show={modalShow} enforceFocus={false}>
        <ModalHeader closeButton onHide={handleCancel}>
          <ModalTitle>Add Pickup Time</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <PickupTimeAddForm
            onSubmit={this.handleAddPickupTime}
            cypress_id="manage-pickup-times-modal"
          />
        </ModalBody>
        <ModalFooter>
          <SubmitButton
            value="Cancel"
            onClick={handleCancel}
            cypress_id="manage-pickup-times-modal-cancel-button"
          />
          <SubmitButton
            value="Add"
            onClick={submitPickupTimeAddForm}
            cypress_id="manage-pickup-times-modal-submit-button"
          />
        </ModalFooter>
      </Modal>
    )
  }

  handleAddPickupTime = values => {
    const { addPickupTime, city, handleConfirm } = this.props

    const payload = {
      city_id: city.id,
      day: values.day,
      timeStart: moment(values.timeStart).toISOString(),
      timeStop: moment(values.timeStop).toISOString(),
    }
    addPickupTime(payload)
    handleConfirm()
  }
}

PickupTimesAddModal.propTypes = {
  city: PropTypes.object.isRequired,
  addPickupTime: PropTypes.func.isRequired,
  modalShow: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  submitPickupTimeAddForm: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  city: state.city.cityById,
})

const mapDispatchToProps = dispatch => {
  return {
    addPickupTime: payload => dispatch(addPickupTime(payload)),
    submitPickupTimeAddForm: () => dispatch(submit('pickupTimeAddForm')),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PickupTimesAddModal)
